import { Button } from "@/components/ui/button";
import thanksImage from "../../public/images/thanks.png";
import { useParams } from "react-router";

export function Thanks() {
  const { indicatorEmail } = useParams();
  return (
    <div className="flex flex-col items-center justify-center gap-10 text-center max-w-md mx-auto">
      <img src={thanksImage} alt="Imagem de agradecimento pela indicação" className="mx-auto w-full" />
      <div className="w-full px-10">
        <Button
          variant="default"
          className="w-full bg-purple-600 text-white hover:bg-purple-700 cursor-pointer"
          onClick={() => window.location.href = `/${indicatorEmail}`}
        >
          Fazer Nova Indicação
        </Button>
      </div>
    </div>
  );
}